// Máscaras comuns para Input (formato IMask)
export const INPUT_MASKS = {
  // Telefone brasileiro
  PHONE_BR: '(00) 00000-0000',
  PHONE_LANDLINE_BR: '(00) 0000-0000',
  
  // Documentos brasileiros
  CPF: '000.000.000-00',
  CNPJ: '00.000.000/0000-00',
  RG: '00.000.000-0',
  
  // CEP
  CEP: '00000-000',
  
  // Data
  DATE: '00/00/0000',
  DATE_TIME: '00/00/0000 00:00',
  
  // Cartão
  CREDIT_CARD: '0000 0000 0000 0000',
  CVV: '000',
  
  // Outros
  TIME: '00:00',
  CURRENCY: 'R$ 000.000,00',
} as const

// Tipos para TypeScript
export type InputMask = typeof INPUT_MASKS[keyof typeof INPUT_MASKS]

// Utilitário para remover máscara
export const removeMask = (maskedValue: string): string => {
  return maskedValue.replace(/[^\d]/g, '')
}

// Utilitário para aplicar máscara manualmente
export const applyMask = (value: string, mask: string): string => {
  let i = 0
  const v = value.toString()
  return mask.replace(/[0]/g, () => v[i++] || '')
}